import { Box, Skeleton } from "@mui/material";

const ROW_COUNT = 10;

const OrderTableSkeleton = () => (
  <Box
    sx={{
      width: "100%",
      bgcolor: "#fff",
      borderRadius: 1,
      border: "1px solid #f0f0f0",
      overflow: "hidden",
    }}
    aria-busy
    aria-label="Loading orders"
  >
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1.5fr 1fr 1fr 1fr 0.7fr 0.6fr",
        gap: 2,
        px: 2,
        py: 1.5,
        bgcolor: "#f5f6fa",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      {[
        "Date",
        "Order No",
        "Customer Name",
        "Payment Type",
        "Amount (₹)",
        "Status",
        "Action",
        "View",
      ].map((label) => (
        <Skeleton
          key={label}
          variant="text"
          width={label === "View" || label === "Action" ? 48 : 90}
          height={24}
        />
      ))}
    </Box>
    {Array.from({ length: ROW_COUNT }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1.5fr 1fr 1fr 1fr 0.7fr 0.6fr",
          gap: 2,
          alignItems: "center",
          px: 2,
          py: 1.75,
          borderBottom: index < ROW_COUNT - 1 ? "1px solid #f0f0f0" : "none",
        }}
      >
        <Skeleton variant="text" width="80%" height={22} />
        <Skeleton variant="text" width="70%" height={22} />
        <Skeleton variant="text" width={`${55 + (index % 3) * 10}%`} height={22} />
        <Skeleton variant="text" width="65%" height={22} />
        <Skeleton variant="text" width="50%" height={22} />
        <Skeleton variant="rounded" width={90} height={28} />
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>
    ))}
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        px: 2,
        py: 1.5,
        bgcolor: "#f5f6fa",
        borderTop: "1px solid #f0f0f0",
      }}
    >
      <Skeleton variant="rounded" width={280} height={36} />
    </Box>
  </Box>
);

export default OrderTableSkeleton;
